import { Client, Account, Storage, ID } from 'appwrite';

const client = new Client()
  .setEndpoint(process.env.REACT_APP_APPWRITE_ENDPOINT || 'https://cloud.appwrite.io/v1')
  .setProject(process.env.REACT_APP_APPWRITE_PROJECT_ID || '6a1ca9310021bf91d86b');

export const account = new Account(client);
export const storage = new Storage(client);
export const BUCKET_ID = process.env.REACT_APP_APPWRITE_BUCKET_ID || '6a1ca97a00274754d723';
export { ID };

export const sendEmailOTP = async (email) => {
  try {
    return await account.createEmailToken(ID.unique(), email);
  } catch (error) {
    console.error('Send OTP error:', error);
    throw error;
  }
};

export const verifyEmailOTP = async (userId, secret) => {
  try {
    return await account.createSession(userId, secret);
  } catch (error) {
    console.error('Verify OTP error:', error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    return await account.get();
  } catch {
    return null;
  }
};

export const logoutUser = async () => {
  try {
    await account.deleteSession('current');
  } catch (error) {
    console.error('Logout error:', error);
  }
};

export const uploadImage = async (file) => {
  try {
    console.log('Uploading image to Appwrite...', {
      bucketId: BUCKET_ID,
      fileName: file.name,
      fileSize: file.size,
      fileType: file.type
    });

    const response = await storage.createFile(
      BUCKET_ID,
      ID.unique(),
      file
    );

    console.log('Upload success:', response);

    const fileUrl = storage.getFileView(BUCKET_ID, response.$id);
    
    console.log('Image URL:', fileUrl.toString());

    return { 
      url: fileUrl.toString(), 
      id: response.$id 
    };
  } catch (error) {
    console.error('Upload error details:', error);
    throw new Error(`Failed to upload image: ${error.message}`);
  }
};

export const getImagePreview = (fileId, width = 800, height = 800) => {
  try {
    const previewUrl = storage.getFilePreview(
      BUCKET_ID, 
      fileId,
      width,    
      height,   
      'center', 
      90,       
      0,       
      '',       
      0,        
      1,        
      0,        
      '',      
      'jpg'     
    );
    
    return previewUrl.toString();
  } catch (error) {
    console.error('Preview error:', error);
    return null;
  }
};

export const getImageViewUrl = (fileId) => {
  try {
    const viewUrl = storage.getFileView(BUCKET_ID, fileId);
    return viewUrl.toString();
  } catch (error) {
    console.error('View URL error:', error);
    return null;
  }
};

export const deleteImage = async (fileId) => {
  try {
    if (!fileId) {
      console.warn('No file ID provided for deletion');
      return;
    }
    console.log('Deleting image:', fileId);
    await storage.deleteFile(BUCKET_ID, fileId);
    console.log('Image deleted successfully');
  } catch (error) {
    console.error('Delete error:', error);
    console.warn('Image may already be deleted or inaccessible');
  }
};

export const isAppwriteFileId = (urlOrId) => {
  if (!urlOrId) return false;
  return /^[a-zA-Z0-9]+$/.test(urlOrId) && !urlOrId.includes('.');
};

export const getProperImageUrl = (imageValue) => {
  if (!imageValue) return null;
  
  if (imageValue.startsWith('http://') || imageValue.startsWith('https://')) {
    return imageValue;
  }
  
  if (isAppwriteFileId(imageValue)) {
    return getImageViewUrl(imageValue);
  }
  
  return imageValue;
};